<template>
  <v-container>
    <div v-if="introduce">
      <v-subheader class="text-subtitle-1 font-weight-bold grey--text text--darken-2">
        <v-icon color="blue darken-2">mdi-folder-settings</v-icon>
        <span class="ml-2">{{$t('lang.conferenceTheme')}}</span>
      </v-subheader>
      <div class="mx-4" v-html="introduce"></div>
    </div>
    <v-subheader v-if="!hideMeetingPic()" class="text-subtitle-1 font-weight-bold grey--text text--darken-2">
      <v-icon color="blue darken-2">mdi-calendar</v-icon>
      <span class="ml-2">{{$t('lang.agenda')}}</span>
    </v-subheader>
    <van-image fit="cover" lazy-load class="mx-4" :src="meetingPicture"/>
  </v-container>
</template>
<style>
img{
  max-width: 100%;
}
</style>
<script>
export default {
  name: 'Introduce',
  props: ['data'],
  computed: {
    introduce () {
      return this.$store.getters.getLanguage === 0 ? this.data.Introduce : this.data.IntroduceEnglish
    },
    meetingPicture () {
      return this.$store.getters.getLanguage === 0 ? this.data.MeetingPicture : this.data.MeetingPictureEnglish
    }
  },
  methods: {
    hideMeetingPic () {
      const img = new Image()
      img.src = this.meetingPicture
      console.log('width=' + img.width + 'height=' + img.height)
      return (img.width === 1 && img.height === 1) || (img.width === 0 && img.height === 0)
    }
  }
}
</script>
